import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import './Landing.css'
import MixLogo from '../components/MixLogo'

const FEATURES = [
  {
    icon: '📱', color: '#dcfce7',
    title: 'WhatsApp Multi-Número',
    desc: 'Conecta ilimitados números de WhatsApp por empresa vía QR. Sin API oficial, sin costos adicionales por número.',
    tags: ['Baileys', 'QR Scan', 'Reconexión auto'],
  },
  {
    icon: '🤖', color: '#ede9fe',
    title: 'Chatbot con IA Gemini',
    desc: 'Configura un bot inteligente por número con base de conocimiento propia. Escala a humano cuando el cliente lo necesite.',
    tags: ['Google Gemini', 'RAG', 'Escalamiento'],
  },
  {
    icon: '💬', color: '#dbeafe',
    title: 'Inbox Unificado',
    desc: 'Todos tus chats de WhatsApp en un solo lugar con tiempo real. Asigna conversaciones, añade notas internas y colabora.',
    tags: ['Socket.io', 'Asignación', 'Notas'],
  },
  {
    icon: '📊', color: '#fef3c7',
    title: 'Pipeline de Ventas',
    desc: 'Tablero Kanban drag & drop para gestionar oportunidades. Desde prospecto hasta cliente cerrado, sin perder el hilo.',
    tags: ['Kanban', 'Drag & Drop', 'Etapas custom'],
  },
  {
    icon: '📢', color: '#fee2e2',
    title: 'Campañas Masivas',
    desc: 'Envía mensajes masivos con delay anti-baneo inteligente. Segmenta por etiquetas y mide resultados en tiempo real.',
    tags: ['Anti-ban delay', 'Segmentación', 'Métricas'],
  },
  {
    icon: '🏢', color: '#f0fdf4',
    title: 'Multi-Tenant SaaS',
    desc: 'Aislamiento total entre clientes. Cada empresa ve solo sus datos. Planes configurables con límites por recurso.',
    tags: ['Aislamiento', 'Roles', 'Planes'],
  },
]

const PLANS = [
  {
    name: 'Starter',
    price: '150',
    desc: 'Ideal para pequeñas empresas que empiezan con WhatsApp.',
    features: [
      { ok: true, text: '2 números de WhatsApp' },
      { ok: true, text: '5 agentes' },
      { ok: true, text: '1 chatbot IA' },
      { ok: true, text: 'Inbox unificado' },
      { ok: true, text: 'Pipeline básico' },
      { ok: false, text: 'Campañas masivas' },
      { ok: false, text: 'API & Webhooks' },
      { ok: false, text: 'Soporte prioritario' },
    ],
    cta: 'Empezar gratis 14 días',
    popular: false,
  },
  {
    name: 'Pro',
    price: '350',
    desc: 'Para equipos de ventas que necesitan automatización real.',
    features: [
      { ok: true, text: '10 números de WhatsApp' },
      { ok: true, text: '25 agentes' },
      { ok: true, text: 'Chatbots IA ilimitados' },
      { ok: true, text: 'Inbox + asignación auto' },
      { ok: true, text: 'Pipeline avanzado' },
      { ok: true, text: 'Campañas masivas' },
      { ok: true, text: 'API & Webhooks' },
      { ok: false, text: 'Soporte prioritario' },
    ],
    cta: 'Empezar gratis 14 días',
    popular: true,
  },
  {
    name: 'Enterprise',
    price: '800',
    desc: 'Para empresas grandes con necesidades de escala y soporte.',
    features: [
      { ok: true, text: 'Números ilimitados' },
      { ok: true, text: 'Agentes ilimitados' },
      { ok: true, text: 'Chatbots IA ilimitados' },
      { ok: true, text: 'Todo lo del plan Pro' },
      { ok: true, text: 'Reportes avanzados' },
      { ok: true, text: 'SLA garantizado' },
      { ok: true, text: 'API & Webhooks' },
      { ok: true, text: 'Soporte prioritario 24/7' },
    ],
    cta: 'Contactar ventas',
    popular: false,
  },
]

const FAQS = [
  {
    q: '¿Necesito la API oficial de WhatsApp Business?',
    a: 'No. Usamos Baileys, una librería open source que conecta WhatsApp directamente vía QR, como WhatsApp Web. Sin costos por mensaje ni aprobaciones de Meta.',
  },
  {
    q: '¿Cómo funciona el aislamiento multi-tenant?',
    a: 'Cada empresa tiene su propio espacio de datos completamente aislado. Los agentes solo ven los contactos, conversaciones y configuraciones de su empresa. El Super Admin gestiona todo desde un panel separado.',
  },
  {
    q: '¿Puedo instalarlo en mi propio servidor (VPS)?',
    a: 'Sí, exactamente para eso está diseñado. Incluye guía de instalación para Contabo y cualquier VPS con Ubuntu. Solo necesitas Node.js, PostgreSQL y Redis. Incluimos docker-compose para simplificar el deployment.',
  },
  {
    q: '¿El chatbot IA puede escalar a un agente humano?',
    a: 'Sí. Puedes configurar palabras clave, tiempo límite o condiciones para que el bot transfiera la conversación a un agente humano automáticamente, con notificación en tiempo real.',
  },
  {
    q: '¿Las campañas masivas pueden hacer que me baneen?',
    a: 'Implementamos delays aleatorios entre mensajes, simulando comportamiento humano. Además puedes configurar límites de envío por hora. Esto reduce significativamente el riesgo, aunque siempre recomendamos prácticas responsables.',
  },
  {
    q: '¿Qué pasa si un número de WhatsApp se desconecta?',
    a: 'El sistema detecta la desconexión y envía una alerta inmediata. La reconexión es automática en la mayoría de casos. Si requiere nuevo QR, el admin recibe notificación para escanear desde el panel.',
  },
]

const TESTIMONIALS = [
  {
    text: 'Antes teníamos 4 personas respondiendo WhatsApp desde el celular. Ahora todo el equipo trabaja desde un solo panel y el bot maneja el 70% de las consultas.',
    name: 'Carlos Mendoza',
    role: 'CEO · Tienda Online MX',
    initials: 'CM',
  },
  {
    text: 'La integración con nuestro proceso de ventas fue clave. El pipeline kanban nos permite ver en qué etapa está cada cliente sin depender de hojas de Excel.',
    name: 'Laura Sánchez',
    role: 'Directora Comercial · Inmobiliaria Sur',
    initials: 'LS',
  },
  {
    text: 'Instalamos en nuestro VPS de Contabo en menos de 2 horas. La guía es clara y el soporte resolvió mis dudas rápido. Ahora somos revendedores también.',
    name: 'Andrés García',
    role: 'CTO · Agencia Digital Colombia',
    initials: 'AG',
  },
]

const INTEGRATIONS = [
  { icon: '🤖', name: 'Google Gemini' },
  { icon: '🐘', name: 'PostgreSQL' },
  { icon: '🔴', name: 'Redis' },
  { icon: '🟢', name: 'Node.js' },
  { icon: '⚛️', name: 'React 18' },
  { icon: '🔌', name: 'Socket.io' },
  { icon: '📦', name: 'Docker' },
  { icon: '🌐', name: 'Nginx' },
]

export default function Landing() {
  const navigate = useNavigate()
  const [scrolled, setScrolled] = useState(false)
  const [mobileOpen, setMobileOpen] = useState(false)
  const [openFaq, setOpenFaq] = useState(null)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20)
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const scrollTo = (id) => {
    setMobileOpen(false)
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <div className="lp">
      {/* NAVBAR */}
      <nav className={`lp-nav${scrolled ? ' scrolled' : ''}`}>
        <div className="lp-nav-inner">
          <a href="#hero" className="lp-logo" onClick={e => { e.preventDefault(); scrollTo('hero') }}>
            <div className="lp-logo-icon" style={{ borderRadius: 8, overflow: 'hidden', lineHeight: 0 }}><MixLogo size={28} /></div>
            MixCRM
          </a>
          <ul className="lp-nav-links">
            <li><a href="#features" onClick={e => { e.preventDefault(); scrollTo('features') }}>Funciones</a></li>
            <li><a href="#how" onClick={e => { e.preventDefault(); scrollTo('how') }}>Cómo funciona</a></li>
            <li><a href="#pricing" onClick={e => { e.preventDefault(); scrollTo('pricing') }}>Precios</a></li>
            <li><a href="#faq" onClick={e => { e.preventDefault(); scrollTo('faq') }}>FAQ</a></li>
          </ul>
          <div className="lp-nav-cta">
            <button className="btn btn-outline" onClick={() => navigate('/login')}>Iniciar sesión</button>
            <button className="btn btn-primary" onClick={() => navigate('/login')}>Empezar gratis →</button>
          </div>
          <div className="lp-hamburger" onClick={() => setMobileOpen(!mobileOpen)}>
            <span style={mobileOpen ? { transform: 'rotate(45deg) translate(5px, 5px)' } : {}} />
            <span style={mobileOpen ? { opacity: 0 } : {}} />
            <span style={mobileOpen ? { transform: 'rotate(-45deg) translate(5px, -5px)' } : {}} />
          </div>
        </div>
      </nav>

      {/* MOBILE MENU */}
      <div className={`lp-mobile-menu${mobileOpen ? ' open' : ''}`}>
        <ul>
          {[['features','Funciones'],['how','Cómo funciona'],['pricing','Precios'],['faq','FAQ']].map(([id, label]) => (
            <li key={id}><a href={`#${id}`} onClick={e => { e.preventDefault(); scrollTo(id) }}>{label}</a></li>
          ))}
        </ul>
        <div className="lp-mobile-btns">
          <button className="btn btn-outline" onClick={() => navigate('/login')}>Iniciar sesión</button>
          <button className="btn btn-primary" onClick={() => navigate('/login')}>Empezar gratis →</button>
        </div>
      </div>

      {/* HERO */}
      <section id="hero" className="lp-hero">
        <div className="lp-hero-inner">
          <div className="lp-hero-content">
            <div className="badge lp-animate">
              <span className="badge-dot" />
              Plataforma SaaS Multi-Tenant · Deployable en VPS
            </div>
            <h1 className="lp-animate lp-animate-delay-1">
              El CRM de WhatsApp que<br /><span className="grad-text">multiplica tus ventas</span>
            </h1>
            <p className="lp-hero-desc lp-animate lp-animate-delay-2">
              Gestiona múltiples números de WhatsApp, automatiza respuestas con IA, cierra ventas con pipeline Kanban y lanza campañas masivas — todo desde un panel profesional.
            </p>
            <div className="lp-hero-actions lp-animate lp-animate-delay-3">
              <button className="btn btn-primary btn-lg" onClick={() => navigate('/login')}>
                Empezar gratis 14 días →
              </button>
              <button className="btn btn-outline btn-lg" onClick={() => scrollTo('how')}>
                Ver demo ▶
              </button>
            </div>
            <div className="lp-hero-social lp-animate lp-animate-delay-3">
              <div className="lp-hero-avatars">
                {['CR','LM','AV','JT','+'].map((l, i) => (
                  <span key={i} style={i === 4 ? { background: '#f1f5f9', color: '#64748b', fontSize: 10 } : {}}>{l}</span>
                ))}
              </div>
              <span>+500 empresas ya usan MixCRM</span>
            </div>
          </div>

          <div className="lp-hero-visual">
            <div className="lp-float-badge lp-float-1">
              <div className="lp-float-icon lp-float-icon-green">🤖</div>
              <div>
                <div style={{ fontWeight: 700, fontSize: 13 }}>Bot respondió</div>
                <div style={{ fontSize: 11, color: '#64748b' }}>hace 2 segundos</div>
              </div>
            </div>
            <div className="lp-mockup">
              <div className="lp-mockup-bar">
                <div className="lp-mockup-dot" />
                <div className="lp-mockup-dot" />
                <div className="lp-mockup-dot" />
                <div className="lp-mockup-url">app.mixcrm.click/inbox</div>
              </div>
              <div className="lp-chat-ui">
                <div className="lp-chat-sidebar">
                  <div className="lp-chat-sidebar-head">INBOX · 12</div>
                  {[
                    { name: 'María López', msg: 'Quiero info del producto...', badge: 3, active: true },
                    { name: 'Carlos R.', msg: 'Ok perfecto, gracias!', badge: 0, active: false },
                    { name: '+52 555 123...', msg: 'Hola buenas tardes', badge: 1, active: false },
                    { name: 'Empresa XYZ', msg: 'Enviamos el pedido ya', badge: 0, active: false },
                    { name: 'Ana Martínez', msg: 'Pueden llamarme?', badge: 2, active: false },
                  ].map((item, i) => (
                    <div key={i} className={`lp-chat-item${item.active ? ' active' : ''}`}>
                      <div className="lp-chat-item-name">{item.name}</div>
                      <div className="lp-chat-item-msg">{item.msg}</div>
                      {item.badge > 0 && <div className="lp-chat-item-badge">{item.badge}</div>}
                    </div>
                  ))}
                </div>
                <div className="lp-chat-main">
                  <div className="lp-chat-head">
                    <div className="lp-chat-avatar">ML</div>
                    <div>
                      <div className="lp-chat-head-name">María López</div>
                      <div className="lp-chat-head-status">● en línea</div>
                    </div>
                  </div>
                  <div className="lp-chat-messages">
                    <div className="lp-msg lp-msg-in">Hola! Quiero info del producto premium 👋<div className="lp-msg-time">10:23</div></div>
                    <div className="lp-msg lp-msg-bot">🤖 ¡Hola María! El plan Premium incluye funciones avanzadas de automatización...<div className="lp-msg-time">10:23</div></div>
                    <div className="lp-msg lp-msg-in">Perfecto. ¿Tienen descuento por anual?<div className="lp-msg-time">10:25</div></div>
                    <div className="lp-msg lp-msg-out">Sí! 20% de descuento pagando anual 🎉<div className="lp-msg-time">10:26 ✓✓</div></div>
                  </div>
                  <div className="lp-chat-input">
                    <div className="lp-chat-input-box">Escribe un mensaje...</div>
                    <div className="lp-chat-send">➤</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="lp-float-badge lp-float-2">
              <div className="lp-float-icon lp-float-icon-blue">📈</div>
              <div>
                <div style={{ fontWeight: 700, fontSize: 13 }}>Conversión +38%</div>
                <div style={{ fontSize: 11, color: '#64748b' }}>este mes</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* STATS */}
      <div className="lp-stats">
        <div className="lp-stats-inner">
          {[
            { num: '500+', label: 'Empresas activas' },
            { num: '2M+', label: 'Mensajes al mes' },
            { num: '99.9%', label: 'Uptime garantizado' },
            { num: '<2s', label: 'Respuesta del bot' },
          ].map((s, i) => (
            <div key={i}>
              <div className="lp-stat-num">{s.num}</div>
              <div className="lp-stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* FEATURES */}
      <section id="features" className="lp section lp-features">
        <div className="container">
          <div className="lp-section-head">
            <div className="badge">Todo en uno</div>
            <h2>Todo lo que necesitas para<br /><span className="grad-text">vender por WhatsApp</span></h2>
            <p>Una plataforma completa que reemplaza 5 herramientas distintas. Sin integraciones complicadas.</p>
          </div>
          <div className="lp-features-grid">
            {FEATURES.map((f, i) => (
              <div key={i} className="lp-feature-card">
                <div className="lp-feature-icon" style={{ background: f.color }}>{f.icon}</div>
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
                <div className="lp-feature-tags">
                  {f.tags.map(t => <span key={t} className="lp-tag">{t}</span>)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section id="how" className="lp section lp-how">
        <div className="container">
          <div className="lp-section-head">
            <div className="badge">Setup en minutos</div>
            <h2>De cero a <span className="grad-text">ventas automatizadas</span><br />en 4 pasos</h2>
            <p>Sin conocimientos técnicos avanzados. Si puedes instalar WhatsApp, puedes usar MixCRM.</p>
          </div>
          <div className="lp-steps">
            {[
              { n: '1', title: 'Crea tu empresa', desc: 'El Super Admin crea tu empresa en el panel con el plan elegido y configura límites y roles.' },
              { n: '2', title: 'Conecta WhatsApp', desc: 'Escanea el QR desde el panel. En segundos tu número queda conectado y listo para recibir mensajes.' },
              { n: '3', title: 'Configura tu bot IA', desc: 'Sube tu base de conocimientos, define el prompt y activa el chatbot Gemini para responder 24/7.' },
              { n: '4', title: 'Vende y automatiza', desc: 'Tu equipo gestiona el inbox, cierra deals en el pipeline y lanza campañas masivas. Todo medible.' },
            ].map((s, i) => (
              <div key={i} className="lp-step">
                <div className="lp-step-num">{s.n}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>

          {/* VPS note */}
          <div style={{ marginTop: 64, background: '#f8fafc', borderRadius: 20, padding: '32px 40px', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', gap: 32, flexWrap: 'wrap' }}>
            <div style={{ fontSize: 48 }}>🖥️</div>
            <div style={{ flex: 1, minWidth: 240 }}>
              <h3 style={{ marginBottom: 8 }}>¿Tu propio servidor? Sin problema.</h3>
              <p style={{ fontSize: 15 }}>MixCRM está diseñado para tu propio servidor. Despliega en Contabo, Hetzner, DigitalOcean o cualquier VPS con Ubuntu. Incluye guía paso a paso, docker-compose y Nginx con SSL automático. Tus datos, tu servidor, control total.</p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <div className="lp-vps-badge">✓ Docker Compose incluido</div>
              <div className="lp-vps-badge">✓ Nginx + SSL automático</div>
              <div className="lp-vps-badge">✓ Guía para Contabo VPS</div>
            </div>
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section id="pricing" className="lp section lp-pricing">
        <div className="container">
          <div className="lp-section-head">
            <div className="badge">Precios transparentes</div>
            <h2>Elige el plan que <span className="grad-text">impulsa tu negocio</span></h2>
            <p>Sin contratos. Sin sorpresas. Cancela cuando quieras. 14 días gratis en todos los planes.</p>
          </div>
          <div className="lp-pricing-grid">
            {PLANS.map((plan, i) => (
              <div key={i} className={`lp-plan${plan.popular ? ' lp-plan-popular' : ''}`}>
                {plan.popular && <div className="lp-plan-badge">⭐ Más popular</div>}
                <div className="lp-plan-name">{plan.name}</div>
                <div className="lp-plan-price">
                  <span className="currency">Bs. </span>
                  <span className="amount">{plan.price}</span>
                  <span className="period"> /mes</span>
                </div>
                <div className="lp-plan-desc">{plan.desc}</div>
                <ul className="lp-plan-features">
                  {plan.features.map((f, j) => (
                    <li key={j}>
                      <span className={f.ok ? 'check' : 'x'}>{f.ok ? '✓' : '✗'}</span>
                      <span style={f.ok ? {} : { color: '#94a3b8' }}>{f.text}</span>
                    </li>
                  ))}
                </ul>
                <button
                  className={`btn lp-plan-btn${plan.popular ? ' btn-primary' : ' btn-outline'}`}
                  onClick={() => navigate('/login')}
                >
                  {plan.cta}
                </button>
              </div>
            ))}
          </div>
          <p style={{ textAlign: 'center', marginTop: 32, fontSize: 14, color: '#94a3b8' }}>
            ¿Necesitas instalación on-premise? <a href="#faq" style={{ color: '#7c3aed', fontWeight: 600 }} onClick={e => { e.preventDefault(); scrollTo('faq') }}>Ver opciones VPS →</a>
          </p>
        </div>
      </section>

      {/* INTEGRATIONS */}
      <section className="lp section lp-integrations">
        <div className="container">
          <div className="lp-section-head">
            <div className="badge">Stack moderno</div>
            <h2>Construido con tecnología <span className="grad-text">de nivel enterprise</span></h2>
            <p>Open source, battle-tested y listo para escalar desde 10 hasta 10,000 conversaciones diarias.</p>
          </div>
          <div className="lp-integration-logos">
            {INTEGRATIONS.map((int, i) => (
              <div key={i} className="lp-int-logo">
                <span>{int.icon}</span>
                {int.name}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="lp section lp-testimonials">
        <div className="container">
          <div className="lp-section-head">
            <div className="badge">Testimonios</div>
            <h2>Lo que dicen nuestros <span className="grad-text">clientes</span></h2>
            <p>Empresas reales, resultados reales.</p>
          </div>
          <div className="lp-testi-grid">
            {TESTIMONIALS.map((t, i) => (
              <div key={i} className="lp-testi">
                <div className="lp-testi-stars">★★★★★</div>
                <div className="lp-testi-text">"{t.text}"</div>
                <div className="lp-testi-author">
                  <div className="lp-testi-avatar">{t.initials}</div>
                  <div>
                    <div className="lp-testi-name">{t.name}</div>
                    <div className="lp-testi-role">{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" className="lp section lp-faq">
        <div className="container">
          <div className="lp-section-head">
            <div className="badge">FAQ</div>
            <h2>Preguntas <span className="grad-text">frecuentes</span></h2>
            <p>Todo lo que necesitas saber antes de empezar.</p>
          </div>
          <div className="lp-faq-list">
            {FAQS.map((faq, i) => (
              <div key={i} className={`lp-faq-item${openFaq === i ? ' open' : ''}`}>
                <div className="lp-faq-q" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                  {faq.q}
                  <span className="lp-faq-arrow">▾</span>
                </div>
                <div className="lp-faq-a">{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA BANNER */}
      <div className="lp-cta-banner">
        <div style={{ position: 'relative' }}>
          <h2>Empieza hoy. Gratis por 14 días.</h2>
          <p>Sin tarjeta de crédito · Cancela cuando quieras · Setup en menos de 10 minutos</p>
          <div className="lp-cta-actions">
            <button className="btn btn-white btn-lg" onClick={() => navigate('/login')}>
              Crear cuenta gratuita →
            </button>
            <button className="btn btn-lg" style={{ background: 'rgba(255,255,255,0.15)', color: 'white', border: '2px solid rgba(255,255,255,0.3)' }} onClick={() => scrollTo('how')}>
              Ver cómo funciona
            </button>
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <footer className="lp-footer">
        <div className="lp-footer-grid">
          <div className="lp-footer-brand">
            <div className="lp-logo" style={{ color: 'white' }}>
              <div className="lp-logo-icon" style={{ borderRadius: 8, overflow: 'hidden', lineHeight: 0 }}><MixLogo size={28} /></div>
              MixCRM
            </div>
            <p>La plataforma SaaS más completa para gestionar WhatsApp de forma profesional. Multi-empresa, IA integrada, lista para VPS.</p>
            <div style={{ marginTop: 20 }}>
              <div className="lp-vps-badge" style={{ fontSize: 12 }}>🖥️ Deploy en Contabo desde $6/mes</div>
            </div>
          </div>
          <div className="lp-footer-col">
            <h4>Producto</h4>
            <ul>
              <li><a href="#features" onClick={e => { e.preventDefault(); scrollTo('features') }}>Funciones</a></li>
              <li><a href="#pricing" onClick={e => { e.preventDefault(); scrollTo('pricing') }}>Precios</a></li>
              <li><a href="#how" onClick={e => { e.preventDefault(); scrollTo('how') }}>Cómo funciona</a></li>
              <li><a href="#faq" onClick={e => { e.preventDefault(); scrollTo('faq') }}>FAQ</a></li>
            </ul>
          </div>
          <div className="lp-footer-col">
            <h4>Técnico</h4>
            <ul>
              <li><a href="#how">Guía VPS</a></li>
              <li><a href="#how">Docker Setup</a></li>
              <li><a href="#how">API REST</a></li>
              <li><a href="#how">Webhooks</a></li>
            </ul>
          </div>
          <div className="lp-footer-col">
            <h4>Empresa</h4>
            <ul>
              <li><a href="#hero">Acerca de</a></li>
              <li><a href="#hero">Contacto</a></li>
              <li><a href="#hero">Privacidad</a></li>
              <li><a href="#hero">Términos</a></li>
            </ul>
          </div>
        </div>
        <div className="lp-footer-bottom">
          <div style={{ color: '#475569', fontSize: 13 }}>© 2025 MixCRM · mixcrm.click · Todos los derechos reservados.</div>
          <div className="lp-footer-socials">
            {['𝕏', 'in', 'f', '▶'].map((s, i) => (
              <div key={i} className="lp-social-btn">{s}</div>
            ))}
          </div>
        </div>
      </footer>
    </div>
  )
}
